import React from 'react';

import { ChoicesOption, ToggleOption } from './OptionControls';

const ROWS = [
    { value: 'revenue', label: () => $t('Revenue') },
    { value: 'expenditure', label: () => $t('Expenditure') },
    { value: 'net', label: () => $t('Net position') },
];

const COLUMNS = [
    { value: 'comparison', label: () => $t('Comparison budget') },
    { value: 'latest_estimate', label: () => $t('Latest estimate') },
    { value: 'variance', label: () => $t('Variance') },
    { value: 'movement', label: () => $t('Movement') },
    { value: 'committed', label: () => $t('Committed') },
    { value: 'uncommitted', label: () => $t('Uncommitted') },
    { value: 'risks', label: () => $t('AFC risks') },
    { value: 'opportunities', label: () => $t('AFC opportunities') },
    { value: 'forecast', label: () => $t('Forecast') },
];

const AREAS = [
    { value: 'cashflow', label: () => $t('Cashflow') },
    { value: 'workforce', label: () => $t('Workforce') },
    { value: 'procurements', label: () => $t('Procurements') },
    { value: 'contracts', label: () => $t('Contract management') },
    { value: 'risks', label: () => $t('Risks') },
    { value: 'issues', label: () => $t('Issues') },
    { value: 'decisions', label: () => $t('Decisions') },
    { value: 'plans', label: () => $t('Milestones') },
    { value: 'roadmap', label: () => $t('Roadmap') },
];

const resolved = (items) => items.map((item) => ({ value: item.value, label: item.label() }));

/**
 * The executive dashboard's options, under its switch on the Sections tab:
 * chip groups for the rows, columns and areas shown, and switches for the
 * definitions footnote and the weighted table.
 */
const DashboardOptions = ({ options, readOnly, onChange }) => {
    const set = (key) => (value) => onChange({ ...options, [key]: value });

    const choices = (key, label, items) => (
        <ChoicesOption
            sectionKey="dashboard"
            definition={{ key, label, choices: resolved(items) }}
            value={options[key]}
            disabled={readOnly}
            onChange={set(key)}
        />
    );

    return (
        <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-3 tw-ps-4 tw-border-s-2 tw-border-charcoal-15">
            {choices('rows', $t('Financial summary rows'), ROWS)}
            {choices('columns', $t('Financial summary columns'), COLUMNS)}
            <ToggleOption
                definition={{
                    label: $t('Definitions footnote'),
                    help: $t('Shown on the dashboard when there is room if the glossary appendix is in the pack, and always when it is not.'),
                }}
                value={options.definitions}
                disabled={readOnly}
                onChange={set('definitions')}
            />
            <ToggleOption
                definition={{ label: $t('Weighted risks and opportunities table'), help: $t('Shown on the dashboard.') }}
                value={options.weighted_table}
                disabled={readOnly}
                onChange={set('weighted_table')}
            />
            {choices('areas', $t('Status by area'), AREAS)}
        </div>
    );
};

export default DashboardOptions;
